/** Staff / salesperson from SQL export column "Name Staff Name". */
export function importRowStaffName(row) {
  return String(
    row?.staffName ?? row?.StaffName ?? row?.nameStaffName ?? row?.["Name Staff Name"] ?? ""
  ).trim();
}

/** Voucher employee field from "Employee Name" column. */
export function importRowEmployeeName(row) {
  return String(row?.employeeName ?? row?.EmployeeName ?? row?.employee ?? "").trim();
}

/** Prefer staff name when present; otherwise employee name (commission / performance). */
export function importRowSalespersonName(row) {
  return importRowStaffName(row) || importRowEmployeeName(row);
}
